import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["AppProvider"] */ "/home/circleci/project/packages/server/src/app/context.tsx");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/packages/server/src/styles/global.scss");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/packages/server/src/components/Icons/styles.module.scss");
